import { NgModule }   from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';

import { ProfileComponent } from './profile.component';
import { UserProfileComponent } from './userProfile.component';
import { MacAddressesComponent } from './macAddresses.component';
import { TravelDefaultsComponent } from './travel-defaults/travel-defaults.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { AuthGuard } from '../../../../src/app/guards/auth.guard';


const profileRoutes: Routes = [
    {
        path: "",
        component: ProfileComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                children: [
                    { path: './', redirectTo: "", pathMatch: "full" },
                    { path: '', component: UserProfileComponent },
                    { path: 'macAddresses', component: MacAddressesComponent },
                    { path: 'travelDefaults', component: TravelDefaultsComponent },
                    { path: 'passwordReset', component: PasswordResetComponent}
               ]
            } 
        ]
    },

];

@NgModule({
    imports: [
        RouterModule.forChild(profileRoutes)
    ],
    exports: [
        RouterModule
    ]
})
     
export class ProfileRoutingModule { }
